import styled, { css } from 'styled-components';
import media from 'client/styles/media';

const Container = styled.div<{ fullWidth?: boolean }>`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  ${({ fullWidth }) =>
    !fullWidth &&
    css`
      ${media.sm} {
        width: 750px;
      }
      ${media.md} {
        width: 970px;
      }
      ${media.lg} {
        width: 1170px;
      }
    `}
`;

export default Container;
